import "@/assets/css/style.scss";
import { createApp } from "vue";
import App from "./app/App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import i18n from "@/i18n";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import iconPack from "./fa-config";
import Breadcrumbs from "./components/breadcrumbs/Breadcrumbs.vue";
import FabButton from "./components/fabbutton/FabButton.vue";
import TopNavigation from "./components/top-navigation/TopNavigation.vue";
import TopNavigationSettings from "@/components/top-navigation-settings/TopNavigationSettings.vue";
import TopNavigationAdministration from "@/components/top-navigation-administration/TopNavigationAdministration.vue";
import TopMenu from "./components/top-menu/TopMenu.vue";
import TablePager from "./components/table-pager/TablePager.vue";
import FormsFilter from "./components/forms-filter/FormsFilter.vue";
import FilterChip from "@/components/filter-chip/FilterChip.vue";
import PageSpace from "@/components/page-space/PageSpace.vue";
import QInputS from "@/components/skeleton/q-input/QInputS.vue";
import QTableS from "@/components/skeleton/q-table/QTableS.vue";
import Vue3Tour from "vue3-tour";
import "vue3-tour/dist/vue3-tour.css";
import VueExcelEditor from "vue3-excel-editor";
import CountryFlag from "vue-country-flag-next";
import { useAnalytics } from "./plugins/analytics";
import { initAuth0 } from "./auth0";
import { LDPlugin } from "launchdarkly-vue-client-sdk";
import { getLaunchDarklyClientId } from "@/utils/platform.config";
import FormValidationScroll from "@/plugins/form-validation-scroll";
import { bootstrapAuthState } from "@/utils/authBootstrap";
import { setupAuthSessionLifecycle } from "@/utils/authSessionLifecycle";

iconPack();

const app = createApp(App);

(async () => {
  app.component("font-awesome-icon", FontAwesomeIcon);
  app.component("Breadcrumbs", Breadcrumbs);
  app.component("FabButton", FabButton);
  app.component("TopNavigation", TopNavigation);
  app.component("TopNavigationSettings", TopNavigationSettings);
  app.component("TopNavigationAdministration", TopNavigationAdministration);
  app.component("TopMenu", TopMenu);
  app.component("TablePager", TablePager);
  app.component("FormsFilter", FormsFilter);
  app.component("FilterChip", FilterChip);
  app.component("PageSpace", PageSpace);
  app.component("QInputS", QInputS);
  app.component("QTableS", QTableS);

  useAnalytics(router);

  app.use(i18n);
  app.use(store);
  app.use(Quasar, quasarUserOptions);
  await initAuth0();
  await bootstrapAuthState();
  app.use(router);
  setupAuthSessionLifecycle(router);
  app.use(Vue3Tour);
  app.use(VueExcelEditor);
  app.use(CountryFlag);
  app.use(FormValidationScroll); // Global form validation scroll
  
  const ldClientId = getLaunchDarklyClientId();
  if (ldClientId) {
    app.use(LDPlugin, {
      clientSideID: ldClientId,
      context: { kind: "user", anonymous: true },
    });
  } else {
    console.warn('LaunchDarkly client-side ID is not configured. Feature flags will not be available.');
  }
  app.mount("#app");
})();
